const baseURL =
  process.env.REACT_APP_NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_URL
    : 'http://localhost:5050';

export default baseURL;
